module.exports = __webpack_public_path__ + "static/coder-41720fdeeea5b2be4f0ae98975736cb5.svg";